<template>
  <div>    
    <b-modal
      id="modal-password"
      ref="modal"
      title="Actualizar Contraseña"
      ok-title="Aceptar"
      cancel-title="Cancelar"
      button-size="sm"
      @show="resetModal"
      @hidden="resetModal"
      @ok="handleOk"
    >
      <form ref="form" @submit.stop.prevent="handleSubmit">
        <b-form-group>
          <label>Contraseña actual</label>
          <b-form-input
            type="password"
            id="password"
            name="password"
            v-model="resetPassword.password"
            placeholder="Ingrese la contraseña"
            minlength="6"
            maxlength="20"
            autocomplete="off"
            required
          />
        </b-form-group>
        <b-form-group>
          <label>Nueva Contraseña</label>
          <b-form-input
            type="password"
            id="newPassword"
            name="newPassword"
            v-model="resetPassword.newPassword"
            placeholder="Ingrese la nueva contraseña"
            minlength="6"
            maxlength="20"
            autocomplete="off"
            required
          />
        </b-form-group>

        <b-form-group>
          <label>Confirmar Contraseña</label>
          <b-form-input
            type="password"
            id="confirmPassword"
            name="confirmPassword"
            v-model="resetPassword.confirmPassword"
            placeholder="Confirme la contraseña"
            minlength="6"
            maxlength="20"
            autocomplete="off"
            required
          />
        </b-form-group>
      </form>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: "UpdatePassword",
  data() {
    return {
      resetPassword: {        
        password: "",
        newPassword: "",
        confirmPassword: "",
      }
    };
  },
  methods: {
    checkFormValidity() {
      const valid = this.$refs.form.checkValidity();
      return valid;
    },
    resetModal() {      
      this.resetPassword.password = "";
      this.resetPassword.newPassword = "";
      this.resetPassword.confirmPassword = "";
    },
    handleOk(evt) {      
      evt.preventDefault();      
      this.handleSubmit();
    },
    handleSubmit() {      
      if (!this.checkFormValidity()) {
        return;
      }    
      const left = this;
      this.axios
        .put(this.$apiURI_users + "/api/v1/users/password", {
          id: this.$store.getters.userId,          
          password_before: this.resetPassword.password,
          password_after: this.resetPassword.newPassword,
          password_confirm: this.resetPassword.confirmPassword
        })
        .then(response => {          
          left.$bvToast.toast("Contraseña actualizada con exito", {
            title: "Datos Actualizados",
            autoHideDelay: 3000,
            variant: "success"
          });          
          left.$refs.modal.hide();
          left.$store.dispatch("logoutUser")
          left.$router.push("/login")
        });
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/layouts/UpdatePassword.vue